module.exports = __webpack_public_path__ + "img/logo_login.6c580531.png";